import React, { useCallback, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Form, Progress } from 'antd';
import StepWizard from 'react-step-wizard';
import PropTypes from 'prop-types';
import Step from './Step';
import Layout from './Layout';
import { QUESTION_TYPE } from '../Question';
import { filterNull, textOnly } from '../../../util/util';
import DataBreachService from '../../../services/DataBreach.service';
import SubmitPage from './SubmitPage';
import useQuery from '../../../util/useQuery';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

const DARABREACH_TYPE_ID = '9c421fcd91f011ef867dfa163e89e3c8';

export default function PreviewForm({
    refId,
    style,
    part,
    dataBreachFormId,
    justPreview,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useQuery();
    const formId = params.get('id');
    const [state, setState] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [form] = Form.useForm();
    // Skip to part in groupQuestion
    const [skipToPart, setSkipToPart] = useState([]);
    const [isSubmited, setIsSubmited] = useState(false);

    // Skip to part in part
    const [navigationSteps, setNavigationSteps] = useState([]);

    const [skipItem, setSkipItem] = useState();

    const values = Form.useWatch('groupQuestion', form);

    const setInstance = (SW) => {
        setState({
            ...state,
            SW,
        });
        setActiveStep(SW.state.activeStep);
    };

    useEffect(() => {
        document.body.style.backgroundColor = '#EDEEF9';
    }, []);

    useEffect(() => {
        if (formId) {
            form.resetFields();
            state?.SW?.goToStep(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formId]);

    const percent = ((activeStep + 1) / part?.part?.length) * 100;

    const format = () => {
        return (
            <strong>{`หน้า ${activeStep + 1} จาก ${
                part?.part?.length
            }`}</strong>
        );
    };

    const lastItem = (array) => array[array.length - 1];

    useEffect(() => {
        // Skip to part in groupQuestion
        const getSkipToPartValues = (question, index) => {
            return question.isSkip
                ? question.answerValue
                      .filter((value) => value.skipToPart)
                      .map((value) => ({
                          ...value,
                          questionName: textOnly(question.questionName),
                          fromPart: index + 1,
                      }))
                : [];
        };

        const skipToPartInQuestion = part?.part?.flatMap((part, index) =>
            part?.groupQuestion.flatMap((question) =>
                getSkipToPartValues(question, index)
            )
        );
        // Skip to part in part
        const skipToPartInPart = part?.part?.flatMap((part, index) => ({
            skipToPart: part?.skipToPart,
            fromPart: index + 1,
        }));
        setSkipToPart(skipToPartInQuestion);
        setNavigationSteps(skipToPartInPart);
    }, [part]);

    const handleLastRadio = useCallback(
        (SW, lastRadio, targetStep) => {
            console.log(SW?.state?.activeStep);
            const lastCheckedValue = lastRadio.value;
            const findSkipto = targetStep.find(
                (skip) => skip.optionName === lastCheckedValue
            );

            if (findSkipto) {
                setSkipItem(findSkipto);
                SW.goToStep(findSkipto.skipToPart);
            } else {
                const activeStepSkip = skipToPart.find(
                    (skip) => skip.fromPart === SW?.state?.activeStep + 1
                );
                if (activeStepSkip) {
                    setSkipItem(null);
                }
                SW.nextStep();
            }
        },
        [skipToPart]
    );

    const handleNoLastRadio = useCallback(
        (SW, upcomingStep) => {
            if (upcomingStep?.skipToPart) {
                SW.goToStep(upcomingStep.skipToPart);
                setSkipItem(upcomingStep);
            } else {
                const activeStepSkip = navigationSteps.find(
                    (skip) => skip.fromPart === SW?.state?.activeStep + 1
                );
                if (activeStepSkip) {
                    setSkipItem(null);
                }
                SW.nextStep();
            }
        },
        [navigationSteps]
    );

    const handleStepWithCurrentStep = useCallback(
        (SW, currentStep) => {
            const currentValues = values[currentStep];
            const targetStep = getSkipToParts(skipToPart, currentStep);
            const upcomingStep = navigationSteps.find(
                (s) => s.fromPart === currentStep + 1
            );

            const radioValues = currentValues
                ? filterNull(
                      currentValues?.map((value) =>
                          value.answerType === QUESTION_TYPE.RADIO &&
                          value.value
                              ? value
                              : null
                      )
                  )
                : [];

            const lastRadio = lastItem(radioValues);
            if (lastRadio) {
                handleLastRadio(SW, lastRadio, targetStep);
            } else {
                handleNoLastRadio(SW, upcomingStep);
            }
        },
        [
            values,
            skipToPart,
            navigationSteps,
            handleLastRadio,
            handleNoLastRadio,
        ]
    );

    const onNextStep = useCallback(() => {
        const { SW } = state;
        const currentStep = SW?.state?.activeStep;
        if (currentStep !== undefined) {
            handleStepWithCurrentStep(SW, currentStep);
        } else {
            SW.nextStep();
        }
    }, [state, handleStepWithCurrentStep]);

    const getSkipToParts = (array, step) =>
        array.filter((a) => a.fromPart === step + 1);

    const onPreviousStep = useCallback(() => {
        const { SW } = state;
        const currentStep = SW.state.activeStep;

        if (skipItem) {
            //check current step is skipToPart - 1
            if (skipItem.skipToPart - 1 === currentStep) {
                SW.goToStep(skipItem.fromPart);
            } else {
                SW.previousStep();
            }
        } else {
            SW.previousStep();
        }
    }, [skipItem, state]);

    const onPreviousToFristStep = useCallback(() => {
        // Reset form
        form.resetFields();
        setIsSubmited(false);
        navigate(`${location.pathname}${location.search}#step1`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    const isLastStep = activeStep === part?.part?.length - 1;

    const checkPartRequired = useCallback((skipItem, ind, item) => {
        if (skipItem && skipItem.skipToPart - 2 === ind) {
            item.groupQuestion.forEach((question) => {
                question.isRequire = false;
            });
        }
        return item;
    }, []);

    const submitDataBreachForm = useCallback(async (payload) => {
        try {
            const { data } = await DataBreachService.submitDataBreachForm(
                payload
            );
            return !!data?.resultData;
        } catch (error) {
            return false;
        }
    }, []);

    const onFinished = async (formValues) => {
        let document;
        let dataBreachTypeName = '';

        const groupQuestion = Object.values(
            formValues?.groupQuestion || {}
        ).map(
            (group) =>
                group?.map((item) => {
                    if (
                        [QUESTION_TYPE.DATE_TIME, QUESTION_TYPE.DATE].includes(
                            item.answerType
                        )
                    ) {
                        item.value =
                            moment(item.value).format('DD/MM/YYYY HH:mm') ||
                            null;
                    }

                    if (item.answerType === QUESTION_TYPE.UPLOAD) {
                        document = item.value;
                    }

                    if (item.storyId === DARABREACH_TYPE_ID) {
                        if (item.value === 'Other') {
                            dataBreachTypeName = `อื่นๆ, ${item.other}`;
                        } else dataBreachTypeName = item.value;
                    }

                    return item;
                }) || null
        );
        const payload = {
            dataBreachFormId,
            dataBreachTypeName,
            jsonData: JSON.stringify({ ...formValues, groupQuestion }),
            document,
        };
        const submited = await submitDataBreachForm(payload);
        setIsSubmited(submited);
    };

    const defaultStyle = {
        mainColor: '#312966',
        textFormat: {
            formName: {
                fontFamily: 'Kanit',
                fontSize: '18px',
            },
            description: {
                fontFamily: 'Kanit',
                fontSize: '16px',
            },
        },
    };

    const mergedStyle = {
        ...defaultStyle,
        ...style,
        textFormat: {
            ...defaultStyle.textFormat,
            ...style?.textFormat,
            formName: {
                ...defaultStyle.textFormat.formName,
                ...style?.textFormat?.formName,
            },
            description: {
                ...defaultStyle.textFormat.description,
                ...style?.textFormat?.description,
            },
        },
    };

    const _mainColor = mergedStyle.mainColor;
    const formName_fontFamily = mergedStyle.textFormat.formName.fontFamily;
    const formName_fontSize = mergedStyle.textFormat.formName.fontSize;
    const description_fontFamily =
        mergedStyle.textFormat.description.fontFamily;
    const description_fontSize = mergedStyle.textFormat.description.fontSize;

    return (
        <Form
            scrollToFirstError={{
                behavior: 'smooth',
                block: 'center',
            }}
            form={form}
            onFinish={onFinished}
            layout="vertical"
        >
            <div className="relative h-full">
                {!isSubmited ? (
                    <div className="py-6 px-4 space-y-4 sarabun whitespace-pre-wrap">
                        <Layout>
                            <div
                                className="h-3 w-full rounded-t-md"
                                style={{ backgroundColor: _mainColor }}
                            ></div>
                            <div className="p-6">
                                <div
                                    style={{
                                        fontFamily: formName_fontFamily,
                                        fontSize: formName_fontSize,
                                    }}
                                >
                                    {parse(part?.formName)}
                                </div>
                                {part?.formDescription && (
                                    <div
                                        style={{
                                            fontFamily: description_fontFamily,
                                            fontSize: description_fontSize,
                                        }}
                                    >
                                        {parse(part?.formDescription)}
                                    </div>
                                )}
                                <div className="pr-12">
                                    <Progress
                                        strokeColor={_mainColor}
                                        percent={percent}
                                        format={format}
                                    />
                                </div>
                            </div>
                        </Layout>

                        <Form.List name="groupQuestion">
                            {() => (
                                <StepWizard
                                    isHashEnabled
                                    instance={setInstance}
                                    onStepChange={({ activeStep }) => {
                                        setActiveStep(activeStep - 1);
                                        window.scrollTo({
                                            top: 0,
                                            behavior: 'smooth',
                                        });
                                    }}
                                >
                                    {part?.part?.map((part, index) => (
                                        <Step
                                            refId={refId}
                                            setIsSubmited={setIsSubmited}
                                            justPreview={justPreview}
                                            hidden={index !== activeStep}
                                            style={style}
                                            isLastStep={isLastStep}
                                            onNextStep={onNextStep}
                                            onPreviousStep={onPreviousStep}
                                            key={part?.id}
                                            part={checkPartRequired(
                                                skipItem,
                                                index,
                                                part
                                            )}
                                            index={index}
                                        />
                                    ))}
                                </StepWizard>
                            )}
                        </Form.List>
                    </div>
                ) : (
                    <SubmitPage onPreviousStep={onPreviousToFristStep} />
                )}
            </div>
        </Form>
    );
}

// PropTypes validation
PreviewForm.propTypes = {
    refId: PropTypes.string,
    style: PropTypes.object,
    part: PropTypes.shape({
        part: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                formName: PropTypes.string,
                formDescription: PropTypes.string,
                groupQuestion: PropTypes.arrayOf(
                    PropTypes.shape({
                        questionName: PropTypes.string.isRequired,
                        answerType: PropTypes.string,
                        isSkip: PropTypes.bool,
                        answerValue: PropTypes.arrayOf(
                            PropTypes.shape({
                                skipToPart: PropTypes.number,
                                optionName: PropTypes.string,
                            })
                        ),
                    })
                ).isRequired,
                skipToPart: PropTypes.number,
            })
        ),
    }).isRequired,
    dataBreachFormId: PropTypes.string.isRequired,
    justPreview: PropTypes.bool,
};
